import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	nextWeek: {
		id: 'eoc.rule-card.time-list.next-week.no-translate',
		defaultMessage: 'next week',
		description: 'The text will shown when start day is later than end day',
	},
	and: {
		id: 'eoc.rule-card.time-list.and.no-translate',
		defaultMessage: '<strong>AND </strong>',
		description: '"And" condition',
	},
});

export default messages;
